import { Component, Injector, OnInit } from '@angular/core';
import { FormGenerico } from '../formgenerico/formgenerico';
import { SysPesquisaDinamica } from 'src/app/model/system/sysPesquisaDinamica';
import { GlobalFunctions } from '../global-functions';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { SysEtiquetaService } from 'src/app/services/system/sys-etiqueta.service';
import { ModeloEtiqueta } from 'src/app/model/geral/modeloEtiqueta';
import { ModeloEtiquetaService } from 'src/app/services/geral/modelo-etiqueta.service';

@Component({
    selector: 'app-etiqueta',
    templateUrl: './formetiqueta.component.html',
    styleUrls: ['./formetiqueta.component.css']
})
export class FormEtiquetaComponent extends FormGenerico<SysPesquisaDinamica> implements OnInit {

    copias: number = 1;
    modeloEtiquetas: ModeloEtiqueta[] = [];
    selectedModeloEtiqueta: ModeloEtiqueta;
    list: any[] = [];
    listSel: any[] = [];
    idTabela: string;

    // Variáveis para armazenar as mensagens de tradução
    etqOptions: { label: string, value: string }[] = [];

    // Variável para armazenar o valor selecionado no dropdown
    selectedContent: string;

    constructor(
        public injector: Injector,
        public api: SysEtiquetaService,
        private modeloEtiquetaService: ModeloEtiquetaService,
        public refDialog: DynamicDialogRef,
        public config: DynamicDialogConfig,
    ) {
        super(injector, api);
        this.obj = new SysPesquisaDinamica();
        this.globalFunctions = new GlobalFunctions(this.translocoService, this.injector);

        // Acesse os dados passados pelo diálogo
        if (this.config.data?.list) {
            this.list = this.config.data.list; // Recebe o objeto list passado
            this.listSel.push(this.config.data.objSel);
            this.idTabela = this.config.data.idTabela;
        }
    }

    override ngOnInit(): void {
        super.ngOnInit();
        this.carregarModeloEtiquetas();
        this.carregarMensagens();
    }

    dataExtraObj(res: any) {
        throw new Error('Method not implemented.');
    }      
    
    // Método para carregar as etiquetas
    carregarModeloEtiquetas(): void {
        this.modeloEtiquetaService.getModeloEtiquetaByTabela(this.idTabela).subscribe(
            (response) => {
                this.modeloEtiquetas = response; // Armazena a resposta na variável
            },
            (error) => {
                console.error('Erro ao carregar as etiquetas:', error);
            }
        );
    }

    // Método para carregar as mensagens de tradução
    carregarMensagens(): void {
        // Carregar as traduções para o dropdown
        this.etqOptions = [
            {
                label: this.translocoService.translate('etq_selected_line_only'),
                value: 'selectedLine'
            },
            {
                label: this.translocoService.translate('etq_all_lines_of_research'),
                value: 'allLines'
            }
        ];
    }

    visualizarEtiqueta(): void {
        const idEmpresa = this.auth.empresa.id;
        const idEtiqueta = this.selectedModeloEtiqueta?.id;
    
        // Verifica se o modelo de etiqueta foi selecionado
        if (!idEtiqueta) {
            this.mostrarMensagemErro('etq_no_model_selected');
            return; // Interrompe a execução caso nenhum modelo esteja selecionado
        }
    
        // Determina qual lista usar (listSel ou list)
        let listAsArray: any[] | null = null;
    
        if (this.selectedContent === 'selectedLine') {
            // Se 'selectedLine' foi selecionado
            if (this.listSel && this.listSel.length > 0) {
                listAsArray = this.listSel;
            } else if (this.list && this.list.length > 0) {
                listAsArray = [this.list[0]]; // Usa o primeiro item de list como fallback
            }
        } else {
            // Caso contrário, usa a lista completa
            if (this.list && this.list.length > 0) {
                listAsArray = this.list;
            }
        }
    
        // Verifica se a lista está vazia ou nula antes de prosseguir
        if (!listAsArray || listAsArray.length === 0) {
            this.mostrarMensagemErro('etq_empty_list_error'); // Exibe a mensagem de erro
            return; // Sai da função antes de tentar gerar a etiqueta
        }
    
        // Se passou na validação, chama o serviço de geração de etiqueta
        this.api.generateReportLabel(idEmpresa, idEtiqueta, listAsArray).subscribe(
            (response) => {
                const blob = response;
                const url = window.URL.createObjectURL(blob);
                window.open(url, '_blank');
                window.URL.revokeObjectURL(url);
            },
            (error) => {
                console.error('Erro ao gerar a etiqueta:', error);
            }
        );
    }
    
    // Método para exibir mensagens de erro
    private mostrarMensagemErro(chaveMensagem: string): void {
        const mensagemErro = this.translocoService.translate(chaveMensagem);
        this.messageService.add({
            severity: 'error',
            summary: this.translocoService.translate('error'),
            detail: mensagemErro
        });
    }    
     
    imprimir(): void {
        const idEmpresa = this.auth.empresa.id;
        const idEtiqueta = this.selectedModeloEtiqueta?.id;
    
        // Verifica se o modelo de etiqueta foi selecionado
        if (!idEtiqueta) {
            this.mostrarMensagemErro('etq_no_model_selected');
            return; // Interrompe a execução caso nenhum modelo esteja selecionado
        }
    
        // Determina qual lista usar (listSel ou list)
        let listAsArray: any[] | null = null;
    
        if (this.selectedContent === 'selectedLine') {
            // Se 'selectedLine' foi selecionado
            if (this.listSel && this.listSel.length > 0) {
                listAsArray = this.listSel;
            } else if (this.list && this.list.length > 0) {
                listAsArray = [this.list[0]]; // Usa o primeiro item de list como fallback
            }
        } else {
            // Caso contrário, usa a lista completa
            if (this.list && this.list.length > 0) {
                listAsArray = this.list;
            }
        }
    
        // Verifica se a lista está vazia ou nula antes de prosseguir
        if (!listAsArray || listAsArray.length === 0) {
            this.mostrarMensagemErro('etq_empty_list_error'); // Exibe a mensagem de erro
            return; // Sai da função antes de tentar gerar a etiqueta
        }
    
        // Chama o serviço de geração de etiqueta
        this.api.generateReportLabel(idEmpresa, idEtiqueta, listAsArray).subscribe(
            (response) => {
                const blob = response;
                const url = window.URL.createObjectURL(blob);
                
                // Abre o PDF em uma nova janela e ativa o comando de impressão
                const printWindow = window.open(url, '_blank');
                if (printWindow) {
                    printWindow.onload = () => {
                        printWindow.print();
                        window.URL.revokeObjectURL(url);
                    };
                } else {
                    console.error('Falha ao abrir o PDF para impressão.');
                }
            },
            (error) => {
                console.error('Erro ao gerar a etiqueta:', error);
            }
        );
    }    

    sair(): void {
        this.refDialog.close(this.obj);
    }

    protected onPropertyChange(propName: string, newValue: any): void {}
}
